<template>
  <div class="wrapper animated fadeIn">
    <DisbursementsFilters @load="load" />

    <div class="card">
      <div class="card-header">
        <i class="icon-clock"></i> Facture coach à traiter
        <div class="pull-right">
          <span class="total inline-block">
            Total ({{ formatPrice(totalPending || "0.00€") }})
          </span>
        </div>
      </div>

      <div class="card-block">
        <DisbursementList v-if="!isLoading" :data="disbursements" pending />
        <Loader v-else :isVisible="isLoading" size="small" />
      </div>
    </div>
  </div>
</template>

<script>
import DisbursementList from "@/components/coach/DisbursementList";
import DisbursementsFilters from "@/components/coach/DisbursementsFilters";
import Loader from "@/components/utils/Loader";

export default {
  components: {
    DisbursementsFilters,
    DisbursementList,
    Loader,
  },

  data() {
    return {
      disbursements: [],
      form: {
        merchant: null,
        coachManagers: [],
      },
      isLoading: false,
    };
  },

  computed: {
    totalPending() {
      let total = 0;

      if (this.disbursements?.length > 0) {
        this.disbursements.forEach((disbursement) => {
          total += disbursement.credit;
        });
      }

      return total;
    },
  },

  methods: {
    async getDisbursements() {
      try {
        this.isLoading = true;

        const { data } = await this.$api.get("/disbursements", {
          params: {
            type: "not-processed",
            merchant: this.form.merchant?.value,
            coachs: this.form.coachs && this.form.coachs.map((c) => c.value),
            coachManagers:
              this.form.coachManagers &&
              this.form.coachManagers?.map(({ value }) => value),
            anomalie: this.form.anomalie?.value,
          },
        });

        this.disbursements = data;
      } catch (e) {
        this.$errorToast("Impossible de charger les factures des coachs");
      } finally {
        this.isLoading = false;
      }
    },

    load(form) {
      this.form = form;

      this.getDisbursements();
    },
  },
};
</script>
